import { getEntity } from 'entman';

import schemas from 'schemas';


export function getProject(state, id) {
  return getEntity(state, schemas.ProjectItem, id);
}
